import React, { useEffect, useState } from 'react'
import moment from 'moment'
import {startOf, add} from 'react-big-calendar/lib/utils/dates'
import { navigate } from 'react-big-calendar/lib/utils/constants'
import { Tooltip } from 'react-tooltip';

function createCalendar(currentDate) {
  if (!currentDate) {
    currentDate = moment()
  } else {
    currentDate = moment(currentDate)
  }

  const first = currentDate.clone().startOf('month')
  const last = currentDate.clone().endOf('month')
  const weeksCount = Math.ceil((first.day() + last.date()) / 7)
  const calendar = Object.assign([], { currentDate, first, last })

  for (let weekNumber = 0; weekNumber < weeksCount; weekNumber++) {
    const week = []
    calendar.push(week)
    calendar.year = currentDate.year()
    calendar.month = currentDate.month()

    for (let day = 7 * weekNumber; day < 7 * (weekNumber + 1); day++) {
      const date = currentDate.clone().set('date', day + 1 - first.day())
      date.calendar = calendar
      week.push(date)
    }
  }

  return calendar
}

function CalendarDate(props) {
  const { dateToRender, dateOfMonth, events = [] } = props
  const isSameDay = dateToRender.isSame(moment(), 'day');
  const isSameMonth = dateToRender.month() === dateOfMonth.month();
  const today = isSameDay && isSameMonth ? 'today' : '';

  const eventsOnThisDay = events.filter(event => {
    const start = moment(event.start).startOf('day');
    let end = moment(event.end).startOf('day');

    if (!start.isSame(end, 'day')) {
      end = end.subtract(1, 'day');
    }
    const target = dateToRender.clone().startOf('day');

    return target.isSameOrAfter(start) && target.isSameOrBefore(end);
  });

  const hasHoliday = eventsOnThisDay.some(e => e.isHoliday === "holiday");
  const annual = eventsOnThisDay.some(e => e.leave_type === "Annual");
  const emergency = eventsOnThisDay.some(e => e.leave_type === "Emergency");
  const medical = eventsOnThisDay.some(e => e.leave_type === "Medical");
  const unpaid = eventsOnThisDay.some(e => e.leave_type === "Unpaid");

  let highlight = '';

  if (isSameMonth) {
    if (hasHoliday) {
      highlight = 'holiday';
    } else if (annual) {
      highlight = 'annual';
    } else if (emergency) {
      highlight = 'emergency';
    } else if (medical) {
      highlight = 'medical';
    } else if (unpaid) {
      highlight = 'unpaid';
    }

    if (isSameDay) {
      highlight = 'today';
    }
  }

  const tooltipId = `calendar-tooltip-${dateToRender.format('YYYY-MM-DD')}`;
  let tooltipContent = '';
  if (eventsOnThisDay.length > 0) {
    const isHoliday = eventsOnThisDay[0].isHoliday === "holiday";
    const leave_type = eventsOnThisDay[0].leave_type;

    const contentParts = eventsOnThisDay.map(event => {
      const leave_type = event.leave_type;
      const leave_session = event.leave_session;

      if (leave_type === "Annual" || leave_type === "Emergency") {
        if (leave_session === null || leave_session === "Full Day") {
          return `<b>Full Day</b><br>`;
        } else if (leave_session === "1st Half") {
          return `<b>1st Half Day</b><br>`;
        } else if (leave_session === "2nd Half") {
          return `<b>2nd Half Day</b><br>`;
        }
      }
    });

    tooltipContent = (isHoliday || (leave_type !== "Annual" && leave_type !== "Emergency"))
      ? `
        <div style="background-color: #fff; padding: 0; border: 1px solid #ccc; border-radius: 8px; width: 100%;">
          <div style="background-color: #DEDEDE; padding: 8px 12px; font-weight: bold; border-bottom: 1px solid #ccc;">
            ${eventsOnThisDay[0].title} ${!isHoliday ? ' Leave' : ''}
          </div>
        </div>
      `
      : `
        <div style="background-color: #fff; padding: 0; border: 1px solid #ccc; border-radius: 8px; width: 100%;">
          <div style="background-color: #DEDEDE; padding: 8px 12px; font-weight: bold; border-bottom: 1px solid #ccc;">
            ${eventsOnThisDay[0].title} Leave
          </div>
          <div style="padding: 10px 12px; color: #000;">
            ${contentParts.join('<br>')}
          </div>
        </div>
      `;
  }

  return (
    <>
      <button
        className={`date ${isSameMonth ? 'in-month' : 'out-month'} ${highlight}`}
        data-tooltip-id={tooltipId}
        data-tooltip-html={tooltipContent}
        style={{
          color: isSameMonth ? undefined : '#999',
          opacity: isSameMonth ? 1 : 0.6,
          cursor: isSameMonth ? 'pointer' : 'default'
        }}
      >
        {dateToRender.date()}
      </button>

      {tooltipContent && (
        <Tooltip
          id={tooltipId}
          place="top"
          positionStrategy="fixed"
          style={{
            color: 'black',
            backgroundColor: '#fff',
            borderRadius: '6px',
            fontSize: '16px',
            padding: 0,
            border: 'none',
            boxShadow: '0 0 10px rgba(0,0,0,0.15)',
          }}
        />
      )}
    </>
  );
}

class Calendar extends React.Component {
  state = {
    calendar: undefined
  }

  componentDidMount() {
    this.setState({ calendar: createCalendar(this.props.date) })
  }

  componentDidUpdate(prevProps) {
    if (this.props.date !== prevProps.date) {
      this.setState({ calendar: createCalendar(this.props.date) })
    }
  }

  render() {
    if (!this.state.calendar) {
      return null
    }

    return (
      <div className="month">
        <div className="month-name">
          {this.state.calendar.currentDate.format('MMMM').toUpperCase()}
        </div>
        {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map((day, index) => (
          <span key={index} className="day">
            {day}
          </span>
        ))}
        {this.state.calendar.map((week, index) => (
          <div key={index}>
            {week.map(date => (
              <CalendarDate
                key={date.toString()}
                dateToRender={date}
                dateOfMonth={this.state.calendar.currentDate}
                events={this.props.events}
                onClick={date =>
                  alert(`${date.format('DD/MM/YYYY')}`)
                }
              />
            ))}
          </div>
        ))}
      </div>
    )
  }
}

class Year extends React.Component {
	static range(date) {
    return [startOf(date, 'year')]
  }

  static navigate(date, action) {
    switch (action) {
      case navigate.PREVIOUS:
        return add(date, -1, 'year')
      case navigate.NEXT:
        return add(date, 1, 'year')
      default:
        return date
    }
  }

  static title(date, { localizer }) {
    return localizer.format(date, 'yearHeaderFormat')
  }

  render() {
    let { date, ...props } = this.props
    const months = []
    const firstMonth = startOf(date, 'year')

    for (let i = 0; i < 12; i++) {
      months.push(
        <Calendar key={i + 1} date={add(firstMonth, i, 'month')} events={this.props.events} />
      )
    }

    return <div className="year">{months.map(month => month)}</div>
  }
}

Year.range = date => {
  return [startOf(date, 'year')]
}

Year.navigate = (date, action) => {
  switch (action) {
    case navigate.PREVIOUS:
      return add(date, -1, 'year')

    case navigate.NEXT:
      return add(date, 1, 'year')

    default:
      return date
  }
}

Year.title = (date, { localizer }) => localizer.format(date, 'yearHeaderFormat')

export default Year
